import { Injectable } from '@angular/core';
import { BonDto } from '@lexi-clients/lexi';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { ExportingEvent } from 'devextreme/ui/data_grid';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

@Injectable()
export class ExportDataGridService {

    /**
     * Export Excel par défaut du contenu d'une data-grid.
     *
     * Depuis la v23.1 de DevExtreme, l'implémentation par défaut a été supprimée. Il est donc nécessaire de le faire explicitement.
     * Voir le lien ci-dessous pour plus d'infos.
     * https://supportcenter.devexpress.com/ticket/details/T1177244/datagrid-pivotgrid-removed-deprecated-default-inner-export-logic
     *
     * @param e Evénement de demande d'export
     * @param filename Nom du fichier à générer
     */
    onExporting(e: ExportingEvent, filename: string) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(filename.toUpperCase());

        exportDataGrid({
            component: e.component,
            worksheet: worksheet
        }).then(function() {
            workbook.xlsx.writeBuffer().then(function(buffer: BlobPart) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), filename + '.xlsx');
            });
        });
    }

    // Reprise 25.1 pour STH
    onExportingReception(e: ExportingEvent, filename: string, reception: BonDto) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(filename.toUpperCase());

        exportDataGrid({
            component: e.component,
            worksheet,
            topLeftCell: { row: 5, column: 1 },
        }).then((cellRange) => {
            // header
            const headerIntitule = worksheet.getRow(1);
            headerIntitule.height = 30;
            worksheet.mergeCells(1, 1, 1, 8);

            headerIntitule.getCell(1).value = reception?.intitule;
            headerIntitule.getCell(1).font = { name: 'Segoe UI Light', size: 22 };
            headerIntitule.getCell(1).alignment = { horizontal: 'center' };

            const headerFournisseurCodeInterne = worksheet.getRow(3);
            const intituleFournisseur = reception?.partenaireSourceIntitule ?? '';
            const codeFournisseur = reception?.partenaireSourceCodeBo ?? '';
            headerFournisseurCodeInterne.getCell(1).value = `Fournisseur :  ${codeFournisseur + ' -'} ${intituleFournisseur}`;

            headerFournisseurCodeInterne.getCell(4).value = `Code interne : ${reception?.codeBo ?? ''}`;

            // footer
            const footerRowIndex = cellRange.to.row + 2;
            const footerRow = worksheet.getRow(footerRowIndex);
            worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

            footerRow.getCell(1).value = `Réceptionnaire : ${reception?.createurComptage ?? ''}`;
            footerRow.getCell(1).alignment = { horizontal: 'right' };
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${reception?.intitule ?? 'reception'}.xlsx`);
            });
        });
    }

    export(grid: any, filename: string) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(filename.toUpperCase());

        exportDataGrid({
            component: grid,
            worksheet: worksheet
        }).then(function() {
            workbook.xlsx.writeBuffer().then(function(buffer: BlobPart) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), filename + '.xlsx');
            });
        });
    }
}
